import React, { useEffect } from "react";
import Iframe from "react-iframe";
import { styled } from '@mui/material/styles';

const Container = styled('div')(({ theme }) => ({
  width: "100%",
  float: "right",
  height: "calc(100vh - 210px)",
  [theme.breakpoints.down('md')]: {
    float: "none",
  },
  left: "0px",
  top: "0px",
  zIndex: 100,
  position: "relative",
}));

const iframeClass = 'indoc-iframe';

const IframeStyleHelper = styled('div')({
  [`& .${iframeClass}`]: {
    border: "none",
    left: "0px",
    top: "0px",
    zIndex: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
  },
});

// InDoc Wrapper Component
const InDoc = props => {
  useEffect(() => {
    const checkChange = () => {
      if (window.innerHeight !== window.screen.height) {
        setTimeout(() => {
          const elem = document.getElementById('indoc_container');
          elem.style = "";
        }, 200);
      }
    };

    const listener = document.addEventListener("fullscreenchange", checkChange);

    return () => {
      document.removeEventListener('fullscreenchange', listener);
    };
  }, []);

  let IframeUrl = props.param ? `${props.url}${props.param}` : `${props.url}`;

  return (
    <React.Fragment>
      <Container id="indoc_container">
        <IframeStyleHelper>
          <Iframe url={IframeUrl} id="indoc" className={iframeClass} title="Interactive Document" allowFullScreen />
        </IframeStyleHelper>
      </Container>
    </React.Fragment>
  );
};

export default InDoc;
